/*eslint-disable*/
import VueI18n from 'vue-i18n';
import Vue from 'vue';

import russianTranslation from '../../translations/ru';
import englishTranslation from '../../translations/en';
import bulgarianTranslation from '../../translations/bg';
import ukrainianTranslations from '../../translations/uk';
import frenchTranslations from '../../translations/fr';
import latvianTranslations from '../../translations/lv';
import spainTranslations from '../../translations/es';

VueI18n.prototype.getChoiceIndex = function (choice, choicesLength) {

  if (this.locale === 'en') {
      choice = Math.abs(choice);
      if (choicesLength === 2) {
          return choice ? choice > 1 ? 1 : 0 : 1;
      }
  }

  if (choice === 0) {
    return 0;
  }

  const teen = choice > 10 && choice < 20;
  const endsWithOne = choice % 10 === 1;

  if (choicesLength < 4) {
    return (!teen && endsWithOne) ? 1 : 2;
  }

  if (!teen && endsWithOne) {
    return 1;
  }

  if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
    return 2;
  }

  return (choicesLength < 4) ? 2 : 3;
};

Vue.use(VueI18n);

const messages = {
  ru: russianTranslation,
  en: englishTranslation,
  bg: bulgarianTranslation,
  uk: ukrainianTranslations,
  fr: frenchTranslations,
  lv: latvianTranslations,
  es: spainTranslations,
};

const i18n = new VueI18n({
  messages,
  fallbackLocale: 'ru'
});

export default i18n;
